import { Alert, Platform } from "react-native";
import { displayLocalNotification } from "../../utils/notifications.js";

/**
 * Notify user that an app was auto-blocked due to flagged severity.
 * @param {string} appName
 */
export async function notifySeverityAutoBlock(appName) {
  const msg = `⚠️ ${appName} was auto-blocked — detected disturbing or explicit content.`;
  if (Platform.OS === "web") {
    return;
  }
  try {
    await displayLocalNotification("Lockbox", msg);
  } catch {
    /* ignore */
  }
  Alert.alert("Lockbox", msg);
}
